export const getMode = (props) => {
    const { theme: { mode } } = props;
    return mode;
};
